import { render, staticRenderFns } from "./DataTableHeaderDummy.vue?vue&type=template&id=bb2bae08&"
import script from "./DataTableHeaderDummy.vue?vue&type=script&lang=js&"
export * from "./DataTableHeaderDummy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports